
import { supabase } from "@/integrations/supabase/client";

export const getCategories = async () => {
  try {
    const { data, error } = await supabase
      .from("categories")
      .select("*")
      .order("name", { ascending: true });

    if (error) {
      console.error("Error fetching categories:", error);
      return [];
    }

    return data || [];
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
};

export const getSubcategories = async (categoryId: number) => {
  try {
    const { data, error } = await supabase
      .from("subcategories")
      .select("*")
      .eq("parent_id", categoryId)
      .order("name", { ascending: true });

    if (error) {
      console.error("Error fetching subcategories:", error);
      return [];
    }

    return data || [];
  } catch (error) {
    console.error("Error fetching subcategories:", error);
    return [];
  }
};
